import { Component, effect } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { CustomerFormat } from '../../../shared/models/customerFormat.model';
import { ItemFormat } from '../../../shared/models/itemFormat.model';
import { CartModule } from '../cart.module';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { Plan } from '../../../shared/models/plan.model';
import { PromoService } from '../../../shared/promo.service';

import { CouponFormat } from '../../../shared/models/couponFormat.model';


@Component({
  selector: 'app-dynamic-payment-container',
  template:`
    <section aria-label="Order Summary" class="dynamic-payment-container">

      <div class="dynamic-payment-container">
        <div class="card-body">
        <div class="dynamic-payment-container__header">
            <h1 class="cart-title" aria-label="Title for payment information step">
              Order Summary
            </h1>
            <hr>
            <div>
              <div class="plan-info" >
                  <div class="plan-name" aria-label="Plan name">{{selectedPlan.name}}</div>
                  <div class="plan-price" aria-label="Plan price">\${{selectedPlan.price}} / month</div>
              </div>

                <!-- <p class="locked-in">Automatically renews each month</p> -->
            </div>
            <div>
              @for(staticItem of staticItemList; track staticItem.cartName) {
                <app-dynamic-payment-component-line-item   
                  [itemFormat]="staticItem">
                </app-dynamic-payment-component-line-item>
              }        
            </div>

            <div>
              @for(dynamicItem of dynamicItemList; track dynamicItem.cartName) {       
                <app-dynamic-payment-component-line-item 
                  [itemFormat]="dynamicItem">
                </app-dynamic-payment-component-line-item>
              }
            </div>
            
            <hr>
            <span>
              <div class="promo-code-title">Promo Code</div> 
              <div class="dynamic-payment-container__header--coupon">
                  <app-dynamic-payment-component-coupon-form></app-dynamic-payment-component-coupon-form>
              </div>
            </span>

            
            @if(discountIsVisible){
              <hr>
              <div class="dynamic-payment-container__header--subtotal" >
                <div class="plan-info d-flex col justify-content-between" style="margin-bottom: .5rem;" >
                  <div class="total-Due row-8" aria-label="Subtotal">Subtotal:</div>
                  <div class="total-Cost row-4" >\${{subTotal  | number:'1.2-2'}}</div>
                </div>
              </div>
              <div class="dynamic-payment-container__header--discount" >
                <div class="plan-info d-flex col justify-content-between" >
                  <div class="total-Due row-8" style="" aria-label="Discount for Promo">Promo Discount:</div>
                  <div class="total-Cost row-4"  >-\${{discountAmmount | number:'1.2-2'}}</div>
                </div>
              </div>
            }
            <!-- 
            <div class="dynamic-payment-container__header--tax">
                <h2 aria-label="Sales tax for service">Discount: \${{salesTax}}</h2>
            </div>
            -->

            <hr>
            <div class="dynamic-payment-container__header--total">
              <div class="plan-info d-flex col justify-content-between" style="margin-bottom: 5px;">
                <div class="total-Due row-8" aria-label="Total amount for service">Total Due:</div>
                <div class="total-Cost row-4" >\${{totalCost}} / month</div>
              </div>
                <div class="locked-in" style="font-weight: 500;">Guaranteed Locked-in Pricing</div>
                <h3 aria-label="Total amount for service"> </h3>
            </div>
        </div>
        </div>
      </div>

      
    </section>
  `,
  styleUrls: ['./dynamic-payment-container.component.scss'],
  imports: [ CartModule, DecimalPipe ],
  standalone: true,
})
export class DynamicPaymentContainerComponent {

  get customer(): CustomerFormat {
    return this.directSessionLogic.customerSignal();
  }
  get selectedPlan(): Plan {
    return this.directSessionLogic.selectedPlanSignalValue;
  }
  get itemList(): ItemFormat[] {
    return this.directSessionLogic.cartItemsSignal();
  }

  staticItemList: ItemFormat[] = [];
  dynamicItemList: ItemFormat[] = [];

  discountIsVisible: boolean = false;
  discountAmmount: number = 0;
  subTotal: number = 0;
  salesTax: number = 0;
  totalCost: number = 0;



  proxyTotalCost: number = 0;


  constructor(
    public directSessionLogic: DirectSessionLogicService,
    public promoService: PromoService,
  ){
    this.totalCost = this.directSessionLogic.trimmedSessionSignal().totalCost;
    this.recalculatingCartCosts(this.promoService.couponSignal());

    effect(() => {
      this.staticItemList = this.itemList?.filter(item => item.isFixed );
      this.dynamicItemList = this.itemList?.filter(item => !item.isFixed );
    });

    effect(() => {
      const coupon = this.promoService.couponSignal();
      this.recalculatingCartCosts(coupon);
    });

    effect(() => {
      const trimmedSessionSS = this.directSessionLogic.trimmedSessionSignal();
      this.totalCost = trimmedSessionSS.totalCost;
    });
  }



  ngOnChanges(){
    console.log("cart ngOnChanges");
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }


  recalculatingCartCosts(coupon: CouponFormat){

    this.discountAmmount = Number.parseFloat(this.directSessionLogic.returnDiscount().toFixed(2) ?? 0);
    if(this.discountAmmount == 0 || Number.isNaN(this.discountAmmount)){ 
      this.discountIsVisible = false; 
    }
    else{ 
      this.discountIsVisible = true; 
    }
    this.subTotal = this.directSessionLogic.trimmedSessionSignal().totalCost + this.discountAmmount;
  }


  removeItem(item: ItemFormat){ //may be removable
    this.directSessionLogic.removeItemFromCartItemsSignal(item);
  }


  getPaymentTotalWithTax(){
    this.salesTax = this.subTotal * this.getSalesTax(this.customer.state);
    this.proxyTotalCost = this.subTotal + this.salesTax;
  }

  protected taxRateByStateList: { [key: string]: number } = {
    'AL': 0.04,
    'AK': 0.00,
    'AZ': 0.056,
    'AR': 0.065,
    'CA': 0.0725,
    'CO': 0.029,
    'CT': 0.0635,
    'DE': 0.00,
    'FL': 0.06,
    'GA': 0.04,
    'HI': 0.04,
    'ID': 0.06,
    'IL': 0.0625,
    'IN': 0.07,
    'IA': 0.06,
    'KS': 0.065,
    'KY': 0.06,
    'LA': 0.0445,
    'ME': 0.055,
    'MD': 0.06,
    'MA': 0.0625,
    'MI': 0.06,
    'MN': 0.06875,
    'MS': 0.07,
    'MO': 0.04225,
    'MT': 0.00,
    'NE': 0.055,
    'NV': 0.0685,
    'NH': 0.00,
    'NJ': 0.06625,
    'NM': 0.05125,
    'NY': 0.04,
    'NC': 0.0475,
    'ND': 0.05,
    'OH': 0.0575,
    'OK': 0.045,
    'OR': 0.00,
    'PA': 0.06,
    'RI': 0.07,
    'SC': 0.06,
    'SD': 0.045,
    'TN': 0.07,
    'TX': 0.0625,
    'UT': 0.0595,
    'VT': 0.06,
    'VA': 0.043,
    'WA': 0.065,
    'WV': 0.06,
    'WI': 0.05,
    'WY': 0.04
  };

  getSalesTax(state: string): number {  
    return this.taxRateByStateList[state];
  }

}
